export const useFileDownload = () => {
    const downloadFile = (url: string, fileName?: string) => {
        const link = document.createElement("a");
        link.href = url;
        link.download = fileName || url.split("/").pop() || "file";
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return {
        downloadFile,
    };
};

